<ng-form class="w-12"
         #stepForm="ngForm">

    @if (shouldShowList) {
    @if (shouldShowToShipping) {
    <div class="m-t-2 flex flex-column flex-top">
        <span class="p1 left">{{'Billing address' | translate}}</span>
        <input-wrap class="m-t-3 left block p2 address-fieldset">
            <checkbox name="to_shipping"
                      [checked]="checkoutFormComponent.data.billing.to_shipping"
                      [(ngModel)]="checkoutFormComponent.data.billing.to_shipping"
                      (ngModelChange)="detectChanges()">
                <span>{{'Same as delivery address' | translate}}</span>
            </checkbox>
        </input-wrap>
    </div>
    }
    <!-- address book entries and add new  -->
    @if (shouldShowNotToShippingPart) {
    <!-- customer addresses -->
    <radio-group [name]="shouldShowToShipping ? 'customer_address_id_billing' : 'customer_address_id'"
                 [value]="data.customer_address_id"
                 [(ngModel)]="data.customer_address_id"
                 (ngModelChange)="detectChanges()">
        @if (!checkoutFormComponent.isGuestCheckout) {
        <div class="flex flex-wrap delivery-options">
            @if (addressBook.addresses.length !== 0) {
            <p class="p1 m-t-6">{{'Your saved addresses' | translate}}</p>
            @for (item of addressBook.addresses; track $index; let i = $index; let isFirst = $first) {
            <div class="m-t-6 w-12">
                <radio class="w-12 p-l-9 left"
                       (click)="handlAddressSelect($event, item.data)"
                       [value]="item.id">
                    <p class="left p1">
                        {{item.data.nickname}}
                    </p>
                    <div class="flex">
                        <p class="left flex-grow"
                           [ngStyle]="{'width': client.isS  ? '250px' : '400px'}">
                            {{item.data.firstname}} {{item.data.lastname}},
                            {{item.data.street_1}},
                            @if (item.data.street_2) {
                            {{item.data.street_2}},
                            }
                            {{item.data.city}}, {{item.data.postcode}}, {{item.data.telephone}}
                        </p>
                        @if(!isBilling){
                        <div class="m-l">
                            <button class="button-inline-2"
                                    (click)="handleEditAddress($event, item.data)"><span class="button__body"
                                      sizeClass="SM: col-1; XL: col-11">{{'Edit' | translate}}</span></button>
                        </div>
                        }
                    </div>
                </radio>
            </div>
            }
            }
        </div>
        }
        @if (shouldShowAddNew) {
        <div class="delivery-options m-t-6 m-b">
            <!-- new address -->
            <radio class="w-12 p-l-9 left"
                   (click)="resetAddress()"
                   [value]="0">
                <span class="flex flex-start p1">{{'Add new address' | translate}}</span>
            </radio>
        </div>
        }
    </radio-group>
    }
    }

    <!-- new address form -->
    @if (shouldShowForm) {
    <address-fieldset [type]="isBilling ? 'billing' : 'shipping'"
                      (saveAddress)="onSaveAddress()"
                      [form]="stepForm"
                      [data]="data"
                      class="block left">
    </address-fieldset>
    }

    <!-- error notice if no address is selected -->
    @if (shouldShowNotToShippingPart && !shouldShowForm) {
    <input-wrap>
        <input type="hidden"
               [(ngModel)]="data.customer_address_id"
               name="customerAddressId"
               required>
    </input-wrap>
    }
</ng-form>